import React from "react";
import logonewnew from "../logonewnew.svg";
const Footer = () => {
  return (
    <div className="footer">
      <section className="bg-footer">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-6 col-md-6 col-sm-4">
              <div className="text-sm-start mt-3 mt-sm-0">
                <h6 className="text-white">
                  <img src={logonewnew} alt="" height="20" />
                </h6>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-8">
              <div className="text-sm-end mt-3 mt-sm-0">
                <p className="text-muted mb-0 font-size-6">
                  2022 © Copyrights All Rights Reserved by{" "}
                  <a
                    className="text-decoration-none text-primary"
                    href="https://legalperfect.in/"
                  >
                    LegalPerfect
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
